import {
  BodyTwoText,
  Heading1,
} from '@code-dot-org/component-library/typography';
import classNames from 'classnames';
import React from 'react';

import i18n from '@cdo/locale';

import codeLogo from '../images/codeLogo.png';

import styles from './account-components.module.scss';

const AccountBanner: React.FunctionComponent<{
  heading: string;
  desc: string;
  showLogo: boolean;
  className?: string;
}> = ({heading, desc, showLogo, className}) => (
  <div className={styles.bannerContainer}>
    {showLogo && (
      <div className={styles.iconContainer}>
        <img src={codeLogo} alt={i18n.codeLogo()} />
      </div>
    )}

    <div className={classNames(className, styles.titleContainer)}>
      <Heading1>{heading}</Heading1>
      <BodyTwoText className={styles.titleDesc}>{desc}</BodyTwoText>
    </div>
  </div>
);

export default AccountBanner;
